import logo from './logo.svg';
import { Routes, Route } from "react-router-dom";
import Home from "./Pages/Home";
import About from "./Pages/About";
import Services from './Pages/Services';
import Product from './Pages/Product';
import Contact from './Pages/Contact'
import Testimonial from './Pages/Testimonial'
import './App.css';
import Header from './Header/Header';
import { useContext , useEffect, useState } from "react";
import ThemeContext from "./Context/ThemeContext";
import Footer from "./Footer/Footer";
import Copywrite from "./Footer/CopyWrite";
import CallToActionCard from "./Component/CallToActionCard"
import TestimonialMarquee from "./Header/TestimonialMarquee"
function App() {
  const { theme, toggleTheme } = useContext(ThemeContext);
  
  return (
    <div className="App"       
    style={{
        background: theme === "light" ? "#fff" : "#222",
        color: theme === "light" ? "#000" : "#fff",
      }}>
       <TestimonialMarquee/>
      <Header/>
      <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/Services" element={<Services />} />
      <Route path="/Product" element={<Product />} />
      <Route path="/Testimonial" element={<Testimonial />} />
      <Route path="/Contact" element={<Contact />} />
    </Routes>
    <CallToActionCard/>
    <footer className='FooterElem'>
        <Footer/>
    </footer>
    <Copywrite/>
    </div>
  );
}

export default App;
